import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { DialogService } from '@app/services/dialog.service';
import { NavigationserviceService } from '@app/services/navigationservice.service';
import { OrderService } from '@app/services/order.service';
import { QuickStatsFilterService } from '@app/services/quick-stats-filter.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { ToastService } from '@app/services/toast.service';
import { TodayCountsService } from '@app/services/today-counts.service';
import { WebsocketRefreshService } from '@app/services/websocket-refresh.service';
import { WebsocketService } from '@app/services/websocket.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription, Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
export interface Order {
  id: string;
  orderId: string;
  orderIcon: string;
  orderType: 'delivery' | 'pickup';
  customerName: string;
  customerCompany: string;
  address: string;
  deliveryDate: string;
  committedTime: string;
  deliveryTime: string;
  driverInitials: string;
  status: 'pending' | 'successful' | 'unsuccessful' | 'cancelled';
  eta: string;
  selected?: boolean;
  driverName: string
}

@Component({
  selector: 'app-driver-order-list',
  templateUrl: './driver-order-list.component.html',
  styleUrl: './driver-order-list.component.scss'
})
export class DriverOrderListComponent {
  currentFilter: string = 'all';
  totalOrders: number = 0;
  pendingCount: number = 0;
  successfulCount: number = 0;
  unsuccessfulCount: number = 0;
  cancelledCount: number = 0;
  arrivedCount: number = 0;
  shippedCount: number = 0;
  enRouteCount: number = 0;
  warehouseCount: number = 0;
  todayDelivery: number = 0;
  todayPickup: number = 0;
  todayTotalDP: number = 0;
  active_driver_count: number = 0;
  Object = Object;

  // Emit today's counts to header
  @Output() todayCountsUpdated = new EventEmitter<{ delivery: number, pickup: number, total: number, active_driver_count: number }>();
  // Date filter
  selectedDate: string = '';

  // Advanced filters
  showAdvancedFilters: boolean = false;
  advancedFilters = {
    customerName: '',
    company: '',
    driver: '',
    city: '',
    dateFrom: '',
    dateTo: ''
  };

  // Column filters
  showDriverFilter: boolean = false;
  showStatusFilter: boolean = false;
  selectedDrivers: string[] = [];
  selectedStatuses: string[] = [];

  // Orders data
  allOrders: Order[] = [];
  orders: any = [];
  filteredOrders: Order[] = [];
  displayedOrders: Order[] = [];

  // Pagination
  pageSize: number = 20;
  currentPage: number = 0;
  isLoading: boolean = true;
  hasMore: boolean = true;
  scrollProgress: number = 0;

  // Selection
  selectedCount: number = 0;
  showBulkActions: boolean = false;

  // Dropdown states
  activeDropdown: string | null = null;
  searchtext: any;
  orderDate: any;
  orderType: any;
  driverId: any;
  orderStatus: any;
  todaysDate: any;
  activeGroupDriverId: any = null;
  activeGroupStatus: any = null;
  groupSelectionActive: boolean = false;
  totalOrderscount: any;
  id: any;
  constructor(
    private router: Router,
    private dialogService: DialogService,
    private orderService: OrderService,
    private todayCountsService: TodayCountsService,
    private quickStatsFilterService: QuickStatsFilterService,
    private authService: AuthServiceService,
    private toastr: ToastrService, private toast: ToastService,
    private websocketService: WebsocketService,
    private websocketRefresh: WebsocketRefreshService,
    public ShareddtaServices: ShareddtaService, private navigationService: NavigationserviceService, private route: ActivatedRoute,
  ) { this.id = this.route.snapshot.params['id']; }

  ngOnInit(): void {
    this.initializeOrderList();
  }
  subscriptionorderlisting!: Subscription;
  subscriptionRefresh!: Subscription;
  lastProcessedOrderId: any;
  listenOrderSocket() {

    this.subscriptionorderlisting =
      this.ShareddtaServices.data$.subscribe((incomingDataJson: string) => {
        this.restoreOrderListFiltersFromLocalStorage();
        try {

          // 🔹 Tumhara EXACT code yahin paste hoga
          // (maine structure thoda safe bana diya hai)

          // 🔹 Parse incoming JSON
          const incomingData = JSON.parse(incomingDataJson);

          // -------------------------
          // 🔹 CASE 1: ETA / STATUS UPDATE
          // -------------------------
          if (incomingData && this.orders) {

            const indexToUpdate = this.orders.findIndex(
              (item: any) => item.id === incomingData.id
            );

            if (indexToUpdate !== -1 && incomingData.refresh === false) {

              this.orders[indexToUpdate].eta = this.orders[indexToUpdate].eta || [{}];
              this.orders[indexToUpdate].eta[0] = this.orders[indexToUpdate].eta[0] || {};

              this.orders[indexToUpdate].eta[0].etda =
                incomingData?.eta?.[0]?.etda;

              this.orders[indexToUpdate].order_status =
                incomingData?.order_status;
              localStorage.setItem('ordersCache', JSON.stringify(this.orders));
            }

            // -------------------------
            // 🔹 CASE 2: FULL REFRESH
            // -------------------------
            else if (incomingData.refresh === true && incomingData.action === 'order_list') {

              if (this.getCurrentUrl.includes('/dashboard') ||
                this.getCurrentUrl.includes('/orders')) {

                setTimeout(() => {
                  this.websocketRefresh.sendOrderListRequest({
                    page: this.currentPage,
                    page_size: 20,
                    search_text: this.searchtext,
                    order_date: this.orderDate,
                    order_status: this.selectedStatuses,
                    order_type: this.orderType,
                    driver_ids: this.driverId
                  });
                }, 300);

                // 🔥 refresh data listener
                this.subscriptionRefresh =
                  this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                    // this.handleRefreshData(data);
                    if (data) {
                      this.orders = (data.result.results || []).map((order: any) => {

                        // 🔥 ETA hamesha array banane ka logic
                        if (order.eta && !Array.isArray(order.eta)) {
                          // backend se object aa raha hai → array me convert
                          order.eta = [order.eta];
                        }

                        if (!order.eta) {
                          // null / undefined ho to empty array
                          order.eta = [];
                        }

                        return order;
                      });
                      this.totalOrders = data.result.count || 0;
                      localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                      // console.log('this.orders',this.orders);
                    }
                  });
              }
            }

            // -------------------------
            // 🔹 CASE 3: NEW ORDER
            // -------------------------
            else if (incomingData.refresh === true &&
              incomingData.action === 'new_order') {

              if (this.getCurrentUrl.includes('/dashboard') ||
                this.getCurrentUrl.includes('/orders')) {

                setTimeout(() => {
                  this.websocketRefresh.sendOrderListRequestpending({
                    page: this.currentPage,
                    page_size: 20,
                    orderid: incomingData.id,
                    search_text: this.searchtext,
                    order_date: this.orderDate,
                    order_status: this.selectedStatuses,
                    order_type: this.orderType,
                    driver_ids: this.driverId
                  });
                }, 300);

                this.subscriptionRefresh =
                  this.ShareddtaServices.refreshdata1$.subscribe((data: any) => {
                    const IncomingData = (data);
                    const item = IncomingData.result.results;
                    const position = IncomingData.result.position;
                    this.totalOrders = IncomingData.result.count;
                    const orderId = IncomingData.result.order_id;
                    if (this.lastProcessedOrderId === orderId) {
                      console.log("Duplicate WS response ignored:", orderId);
                      return;
                    }
                    this.lastProcessedOrderId = orderId;
                    if (position >= 0 && position <= (this.currentPage + 1) * 20) {
                      this.orders.splice(position - 1, 0, item);
                    }

                    this.totalOrders = data.result.count || 0;
                    localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                  });
              }
            }
            this.fetchOrderCounts();

          }

        } catch (error) {
          console.error('Error parsing incoming JSON data:', error);
        }
      });
  }


  /**
   * Initialize order list - Setup subscriptions and fetch initial data
   */
  nextPageUrl: string | null = null;
  private destroy$ = new Subject<void>();
  private initializeOrderList(): void {

    // Subscribe to loading state from service
    // this.orderService.getLoading().subscribe(loading => {
    //   this.isLoading = loading;
    // });

    // Subscribe to order data
    if (this.getPreviousUrl.includes('/order-detail') || this.getPreviousUrl.includes('/order-detail')) {

    }
    this.orderService.getOrderData1().subscribe(data => {
      if (!data) return;

      const newOrders = data.result?.results || [];

      // 🔹 STEP 1 — Restore selections + apply active group on new page
      newOrders.forEach((order: any) => {

        // Case 1️⃣ — Pehle manually selected
        if (this.selectedOrderIds.has(order.id)) {
          order.selected = true;
        }

        // Case 2️⃣ — Group selection active → auto select
        else if (
          this.groupSelectionActive &&
          this.activeGroupDriverId !== null &&
          order.current_driver.id === this.activeGroupDriverId &&
          order.order_status === this.activeGroupStatus
        ) {
          order.selected = true;

          // add in memory also
          this.selectedOrderIds.add(order.id);
        }

        // Case 3️⃣ — Normal
        else {
          order.selected = false;
        }

      });


      if (this.currentPage === 0) {
        this.orders = newOrders;
      } else {
        this.orders = [...this.orders, ...newOrders];
      }
      this.isLoading = false;
      this.allOrders = [...this.orders];

      // 🔹 STEP 3 — Update filter counts
      if (data.result?.count !== undefined) {
        this.totalOrders = data.result.count;
      }


      // 🔹 STEP 5 — Recalculate selection & bulk bar
      this.updateSelectionCount();
    });




    // Subscribe to count loading state
    this.orderService.getCountLoading().subscribe(loading => {
      // Handle count loading if needed
    });

    // Subscribe to count data
    this.orderService.getOrderCount().subscribe(data => {
      if (data && data.result && data.result.all) {

        const allStatuses = data.result.all;

        // Total orders (sab counts ka sum)


        // Har status ka count nikal lo
        this.pendingCount = this.getStatusCount(allStatuses, 'pending');
        this.successfulCount = this.getStatusCount(allStatuses, 'successful');
        this.unsuccessfulCount = this.getStatusCount(allStatuses, 'unsuccessful');
        this.cancelledCount = this.getStatusCount(allStatuses, 'cancelled');
        this.enRouteCount = this.getStatusCount(allStatuses, 'en-route');
        this.shippedCount = this.getStatusCount(allStatuses, 'shipped');
        this.arrivedCount = this.getStatusCount(allStatuses, 'arrived');
        this.warehouseCount = this.getStatusCount(allStatuses, 'warehouse');
        const todayList = data.result.today;
        this.todayDelivery = this.getTypeCount(todayList, 'delivery');
        this.todayPickup = this.getTypeCount(todayList, 'pickup');
        this.todayTotalDP = this.todayDelivery + this.todayPickup;
        this.active_driver_count = data.result.active_driver_count || 0;
        console.log('Active Driver Count:', this.active_driver_count);

        // Update counts in service for header to display
        this.todayCountsService.updateTodayCounts(this.todayDelivery, this.todayPickup, this.active_driver_count);
        this.totalOrderscount = this.pendingCount + this.successfulCount + this.unsuccessfulCount + this.cancelledCount + this.enRouteCount + this.shippedCount + this.arrivedCount + this.warehouseCount;
        const activefilter = localStorage.getItem('driveractiveFilter')
        if (activefilter == 'today') {
          this.totalOrderscount = this.todayDelivery + this.todayPickup;
        }
        if (activefilter == 'pending') {
          this.currentFilter = 'pending'
          this.totalOrderscount = this.pendingCount
        }
        // Emit today's counts to header component
        this.todayCountsUpdated.emit({
          delivery: this.todayDelivery,
          pickup: this.todayPickup,
          total: this.todayTotalDP,
          active_driver_count: this.active_driver_count,
        });
      }
    });

    this.quickStatsFilterService.quickStatsFilter$
      .pipe(
        debounceTime(350), // 🔹 reduce debounce for snappy feel
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)), takeUntil(this.destroy$)
      )
      .subscribe(filter => {

        let changed = false;

        // 🔥 Sirf jab real change ho tabhi mark karo
        if (filter.orderDate !== undefined && filter.orderDate !== this.orderDate) {
          this.orderDate = filter.orderDate;
          changed = true;
        }

        if (filter.orderType !== undefined) {
          const newType = filter.orderType === 'todayOrders' ? null : filter.orderType;
          if (newType !== this.orderType) {
            this.orderType = newType;
            changed = true;
          }
        }

        if (filter.searchtext !== undefined && filter.searchtext !== this.searchtext) {
          this.searchtext = filter.searchtext;
          changed = true;
        }

        // Force 'changed' if this is an initialized state where we have an active filter 
        if (filter.orderType !== undefined) {
          changed = true;
        }

        // If nothing actually changed, we don't need to re-fetch unless navigating back
        if (!changed && this.orders.length > 0) {
          return;
        }

        // 🔹 Ab hi reset + reload
        console.log('Real filter changed → reload list');

        this.currentPage = 0;
        this.orders = [];
        const activefilter = localStorage.getItem('driveractiveFilter')
        let date = new Date();
        let formatDate =
          date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0');
        this.todaysDate = formatDate;
        // this.fetchOrderCounts();
        if (activefilter == 'today') {
          this.totalOrderscount = this.todayDelivery + this.todayPickup;
          this.orderDate = this.todaysDate
          this.fetchOrders();
        }
        if (activefilter == 'pending') {
          this.currentFilter = 'pending'
          this.orderDate = ''
          this.fetchOrders();
        }
        if (activefilter == 'successful') {
          this.currentFilter = 'successful'
          this.orderDate = this.todaysDate
          this.fetchOrders();
        }
        if (activefilter == 'unsuccessful') {
          this.currentFilter = 'unsuccessful'
          this.orderDate = this.todaysDate
          this.fetchOrders();
        }
        if (activefilter == 'cancelled') {
          this.currentFilter = 'cancelled'
          this.orderDate = this.todaysDate
          this.fetchOrders();
        }
        if (activefilter == null) {
          this.orderDate = this.todaysDate
          this.fetchOrders();
        }

      });




  }
  getStatusCount(list: any[], status: string): number {
    const found = list.find(item => item.order_status === status);
    return found ? found.count : 0;
  }
  getTypeCount(list: any[], type: string): number {
    const found = list.find(item => item.order_type === type);
    return found ? found.count : 0;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    localStorage.setItem('fromOrderDetail', 'true');
  }


  /**
   * Fetch orders from API with current filters
   */
  private fetchOrders(): void {
    const page = this.currentPage; // API expects 0-based index
    this.orderService.driverOrderListPending1(
      this.searchtext,  // search_text
      this.orderDate,  // order_date
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.orderType,  // order_type
      this.id,  // driver_id
      page   // page
    );
  }


  /**
   * Fetch order counts for filters
   */
  private fetchOrderCounts(): void {
    let date = new Date();
    let formatDate =
      date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
    this.todaysDate = formatDate;
    this.orderService.orderCount(
      this.orderDate,  // order_date
      this.orderType,  // order_type
      this.id,  // driver_id
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.todaysDate,  // today_date
      this.searchtext,  // search_text
      null,  // ispending
    );
  }

  /**
   * Load mock orders data (60 orders)
   */
  loadOrders(): void {
    const customers = [
      { name: 'Gucci / Jeevan', company: 'Lexicor' },
      { name: 'Receiving Dept', company: 'Spiral Master' },
      { name: 'Rob', company: 'Metro Insulation' },
      { name: 'Sarah Johnson', company: 'Tech Solutions Inc' },
      { name: 'Michael Chen', company: 'Global Logistics' },
      { name: 'Emma Wilson', company: 'FastTrack Shipping' },
      { name: 'John Smith', company: 'Acme Corporation' },
      { name: 'Lisa Anderson', company: 'Prime Delivery' },
      { name: 'David Brown', company: 'Express Services' },
      { name: 'Maria Garcia', company: 'QuickShip Inc' }
    ];

    const addresses = [
      '151 City Centre Drive, Mississauga, ON, Canada',
      '6611 Innovator Drive, Mississauga, ON, Canada',
      '315 Spadina Avenue, Toronto, ON, Canada',
      '2500 University Drive, Calgary, AB, Canada',
      '890 Yonge Street, Toronto, ON, Canada',
      '1234 Main Street, Vancouver, BC, Canada',
      '5678 Oak Avenue, Montreal, QC, Canada',
      '9012 Pine Road, Ottawa, ON, Canada'
    ];

    const drivers = ['TR', 'AM', 'JK', 'MB', 'SD', 'PK'];
    const driverName = ['Tony Rao', 'Ammey Jackson', 'Shubham Pandey', 'Aviansh Singh', 'Satyam Pandey', 'Pawan Singh'];
    const driverFullName =
      driverName[Math.floor(Math.random() * driverName.length)];
    const statuses: Array<'pending' | 'successful' | 'unsuccessful' | 'cancelled'> = ['pending', 'pending', 'pending', 'successful', 'unsuccessful'];

    // Generate 60 orders
    for (let i = 1; i <= 60; i++) {
      const customer = customers[Math.floor(Math.random() * customers.length)];
      const address = addresses[Math.floor(Math.random() * addresses.length)];
      const driver = drivers[Math.floor(Math.random() * drivers.length)];
      const driverFullName = driverName[Math.floor(Math.random() * driverName.length)];
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      const hour = 1 + Math.floor(Math.random() * 11);
      const minute = Math.floor(Math.random() * 60);
      const ampm = Math.random() > 0.5 ? 'AM' : 'PM';
      const isPickup = Math.random() < 0.3;
      this.allOrders.push({
        id: `order-${6248900 + i}`,
        orderId: `${123400 + i}`,
        orderIcon: isPickup ? 'P' : 'D',
        orderType: isPickup ? 'pickup' : 'delivery',
        customerName: customer.name,
        customerCompany: customer.company,
        address: address,
        deliveryDate: 'Fri Dec 12 2025',
        committedTime: `${hour.toString().padStart(2, '0')}:00 ${ampm}`,
        deliveryTime: `${hour}:${minute.toString().padStart(2, '0')} ${ampm}`,
        driverInitials: driver,
        driverName: this.formatDriverName(driverFullName),
        status: status,
        eta: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')} ${ampm}`,
        selected: false
      });
    }

    this.orders = [...this.allOrders];
  }
  formatDriverName(fullName: string): string {
    const parts = fullName.trim().split(' ');

    if (parts.length === 1) {
      return parts[0];
    }

    const isVirtual = parts.some(p => p.toLowerCase().includes('truck') || p.toLowerCase().includes('zone'));
    const hasNumbers = /\d/.test(fullName);

    if (isVirtual || hasNumbers) {
      return fullName;
    }

    const firstName = parts[0];
    const initials = parts.slice(1).map(p => p.charAt(0).toUpperCase());

    return `${firstName} ${initials.join(' ')}`;
  }

  /**
   * Setup infinite scroll
   */

  // @HostListener('window:scroll', [])
  // onScroll(): void {
  //   const scrollTop = window.scrollY || document.documentElement.scrollTop;
  //   const windowHeight = window.innerHeight;
  //   const docHeight = document.documentElement.scrollHeight;

  //   const scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up';
  //   this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // prevent negative scroll

  //   // --- Scroll Down → Load Next Page ---
  //  if (scrollDirection === 'down' &&  docHeight > 1000 && (docHeight - (scrollTop + windowHeight) <= 100) && this.nextPageUrl) 
  //  {
  //     if(this.nextPageUrl == 'null'){
  //       return
  //     }
  //     const nextPageMatch = this.nextPageUrl.match(/page=(\d+)/) || 0;
  //     const nextPage = nextPageMatch ? Number(nextPageMatch[1]) : this.currentPage + 1;
  //     this.currentPage = nextPage - 1;
  //     localStorage.setItem('pageIndex', JSON.stringify(this.currentPage));
  //       this.orderService.orderList(
  //       null,  // search_text
  //       null,  // order_date
  //       this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
  //       null,  // order_type
  //       null,  // driver_id
  //       this.currentPage   // page
  //     );
  //   }
  // }
  loadingNextPage = false;

  onTableScroll(event: any): void {
    const scrollTop = event.target.scrollTop;
    const scrollHeight = event.target.scrollHeight;
    const clientHeight = event.target.clientHeight;

    const scrollDirection = scrollTop > (this.lastScrollTop || 0) ? 'down' : 'up';
    this.lastScrollTop = scrollTop;

    if (
      scrollDirection === 'down' &&
      this.nextPageUrl &&
      this.nextPageUrl !== 'null' &&
      this.nextPageUrl !== '' &&
      scrollHeight - (scrollTop + clientHeight) <= 100 &&
      !this.loadingNextPage
    ) {
      this.loadNextPage();
    }

  }
  loadNextPage(): void {
    if (!this.nextPageUrl || this.loadingNextPage) return;

    this.loadingNextPage = true;

    const match = this.nextPageUrl.match(/page=(\d+)/);
    const nextPage = match && match[1] ? Number(match[1]) : this.currentPage + 1;

    this.currentPage = nextPage - 1;

    this.orderService.orderList(
      this.searchtext,  // search_text
      this.orderDate,  // order_date
      this.currentFilter === 'all' ? null : this.currentFilter,  // order_status
      this.orderType,  // order_type
      this.driverId,
      this.currentPage
    );

    // service subscription will update `orders` automatically
    setTimeout(() => this.loadingNextPage = false, 500); // optional small delay
  }

  /**
   * Update scroll progress bar
   */
  updateScrollProgress(): void {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    this.scrollProgress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
  }

  /**
   * Load more orders (pagination)
   */
  loadMoreOrders(): void {
    if (this.isLoading || !this.hasMore) return;

    this.isLoading = true;

    // Simulate loading delay
    setTimeout(() => {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      const nextBatch = this.filteredOrders.slice(startIndex, endIndex);

      if (nextBatch.length > 0) {
        this.displayedOrders = [...this.displayedOrders, ...nextBatch];
        this.currentPage++;
      }

      this.hasMore = endIndex < this.filteredOrders.length;
      this.isLoading = false;
    }, 300);
  }

  /**
   * Apply all active filters
   */
  // applyFilters(): void {
  //   this.filteredOrders = this.orders.filter((order: { status: string; driverInitials: string; customerName: string; customerCompany: string; }) => {
  //     // Status filter
  //     if (this.currentFilter !== 'all' && order.status !== this.currentFilter) {
  //       return false;
  //     }

  //     // Driver filter
  //     if (!this.selectedDrivers.includes('all') && 
  //         !this.selectedDrivers.includes(order.driverInitials)) {
  //       return false;
  //     }

  //     // Status column filter
  //     if (!this.selectedStatuses.includes('all') && 
  //         !this.selectedStatuses.includes(order.status)) {
  //       return false;
  //     }

  //     // Advanced filters
  //     if (this.advancedFilters.customerName && 
  //         !order.customerName.toLowerCase().includes(this.advancedFilters.customerName.toLowerCase())) {
  //       return false;
  //     }

  //     if (this.advancedFilters.company && 
  //         !order.customerCompany.toLowerCase().includes(this.advancedFilters.company.toLowerCase())) {
  //       return false;
  //     }

  //     return true;
  //   });

  //   // Reset pagination
  //   this.currentPage = 1;
  //   this.displayedOrders = [];
  //   this.hasMore = true;
  //   this.loadMoreOrders();
  // }
  onStatusChange(event: any): void {
    const value = event.target.value;
    const checked = event.target.checked;

    if (checked) {

      // agar all hai aur koi aur select ho raha hai → all hata do
      if (value !== 'all' && this.selectedStatuses.includes('all')) {
        this.selectedStatuses = this.selectedStatuses.filter(s => s !== 'all');
      }

      if (!this.selectedStatuses.includes(value)) {
        this.selectedStatuses.push(value);
      }

    } else {
      // remove
      this.selectedStatuses = this.selectedStatuses.filter(s => s !== value);
    }
    this.saveOrderListFiltersToLocalStorage();
    this.applyFilters();
  }


  applyFilters(): void {
    this.orders = [];
    this.currentPage = 0;


    if (this.selectedStatuses.length > 0) {
      // pending,successful,cancelled
      this.currentFilter = this.selectedStatuses.join(',');
    } else {
      // agar kuch bhi select nahi hai to all
      this.currentFilter = 'all';
    }
    this.fetchOrders();
    this.fetchOrderCounts();
  }
  /**
   * Change status filter
   */
  setFilter(filter: string): void {

    // Chips se click aaya hai → dropdown ko bhi sync karo
    if (filter === 'all') {
      // sab clear
      this.selectedStatuses = [];
      this.currentFilter = 'all';
    } else {
      // single select
      this.selectedStatuses = [filter];
      this.currentFilter = filter;
    }

    this.orders = [];
    this.currentPage = 0;
    this.saveOrderListFiltersToLocalStorage();
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  setDatefilter(): void {
    this.orders = [];
    this.currentPage = 0;
    this.saveOrderListFiltersToLocalStorage();
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Toggle advanced filters panel
   */
  toggleAdvancedFilters(): void {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  /**
   * Apply advanced filters
   */
  applyAdvancedFilters(): void {
    this.currentPage = 0;
    this.fetchOrders();
    this.fetchOrderCounts();
    this.showAdvancedFilters = false;
  }

  /**
   * Reset advanced filters
   */
  resetAdvancedFilters(): void {
    this.advancedFilters = {
      customerName: '',
      company: '',
      driver: '',
      city: '',
      dateFrom: '',
      dateTo: ''
    };
    this.currentPage = 0;
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Clear all filters
   */
  clearFilters(): void {
    this.orders = [];
    localStorage.setItem('ordersCache', JSON.stringify(this.orders));
    this.currentFilter = 'all';
    this.orderDate = null;
    this.orderType = null;
    this.driverId = null;
    this.searchtext = null;
    this.advancedFilters = {
      customerName: '',
      company: '',
      driver: '',
      city: '',
      dateFrom: '',
      dateTo: ''
    };
    this.selectedDrivers = [];
    this.selectedStatuses = [];
    this.currentPage = 0;
    // Deselect all quick stats tabs in header
    this.quickStatsFilterService.updateQuickStatsFilter(null, null, null, null);
    this.selectedOrderIds.clear();        // global selection memory clear
    this.orders.forEach((o: { selected: boolean; }) => o.selected = false); // current UI clear
    this.updateSelectionCount();
    this.groupSelectionActive = false;
    this.activeGroupDriverId = null;
    this.activeGroupStatus = null;
    localStorage.removeItem('orderHeaderActiveTab');
    localStorage.removeItem('orderHeaderSearch');
    this.removeOrderListFiltersFromLocalStorage();
    this.nextPageUrl = localStorage.getItem('nextPageUrl');
    // aur bhi filter ho toh yahan restore karein
    this.fetchOrders();
    this.fetchOrderCounts();
  }

  /**
   * Toggle order selection
   */
  toggleOrderSelection(order: Order): void {
    order.selected = !order.selected;
    this.updateSelectionCount();
  }

  /**
   * Select all orders
   */
  selectAll(event: any): void {
    const checked = event.target.checked;
    this.filteredOrders.forEach(order => order.selected = checked);
    this.updateSelectionCount();
  }

  /**
   * Clear selection
   */
  clearSelection(): void {
    this.orders.forEach((order: { selected: boolean; }) => order.selected = false);
    this.updateSelectionCount();
  }

  /**
   * Update selection count
   */
  // updateSelectionCount(): void {
  //   this.selectedCount = this.orders.filter((o: { selected: any; }) => o.selected).length;
  //   this.showBulkActions = this.selectedCount > 0;
  // }
  selectedOrderIds: Set<number> = new Set();

  updateSelectionCount(): void {

    // 🔹 Sync current page selection with global Set
    this.orders.forEach((o: any) => {
      if (o.selected) {
        this.selectedOrderIds.add(o.id);
      } else {
        this.selectedOrderIds.delete(o.id);
      }
    });

    // 🔹 Aapka original logic (unchanged behaviour)
    this.selectedCount = this.orders.filter((o: any) => o.selected).length;
    this.showBulkActions = this.selectedCount > 0;

    // console.log('Selected IDs (all pages):', Array.from(this.selectedOrderIds));
  }
  // toggleRowSelection(clickedOrder: any) {

  //   const targetDriverId = clickedOrder.current_driver.id;
  //   const targetStatus  = clickedOrder.order_status;

  //   // 🔹 Decide: select group or unselect group (toggle logic)
  //   const shouldSelect = !clickedOrder.selected;

  //   // 🔹 Loop through all currently loaded orders
  //   this.orders.forEach((order: any) => {

  //     // Match condition → same driver + same status
  //     if (
  //       order.current_driver.id === targetDriverId &&
  //       order.order_status === targetStatus
  //     ) {
  //       order.selected = shouldSelect;   // select OR unselect whole group
  //     }

  //   });

  //   // 🔹 Sync count, bulk bar, global memory (existing logic)
  //   this.updateSelectionCount();
  // }
  toggleRowSelection(clickedOrder: any) {

    const targetDriverId = clickedOrder.current_driver.id;
    const targetStatus = clickedOrder.order_status;

    // 🔹 Decide: select OR unselect group
    const shouldSelect = !clickedOrder.selected;

    // 🔹 Save / clear active group
    if (shouldSelect) {
      // Group ON
      this.activeGroupDriverId = targetDriverId;
      this.activeGroupStatus = targetStatus;
      this.groupSelectionActive = true;
    } else {
      // Group OFF
      this.activeGroupDriverId = null;
      this.activeGroupStatus = null;
      this.groupSelectionActive = false;
    }

    // 🔹 Loop through all currently loaded orders
    this.orders.forEach((order: any) => {

      if (
        order.current_driver.id === targetDriverId &&
        order.order_status === targetStatus
      ) {
        order.selected = shouldSelect;

        // 🔹 Maintain selected ids memory
        if (shouldSelect) {
          this.selectedOrderIds.add(order.id);
        } else {
          this.selectedOrderIds.delete(order.id);
        }
      }

    });

    // 🔹 Same existing logic
    this.updateSelectionCount();
  }




  /**
   * Toggle action dropdown
   */
  toggleDropdown(orderId: string): void {
    this.activeDropdown = this.activeDropdown === orderId ? null : orderId;
  }

  /**
   * Close all dropdowns
   */
  closeAllDropdowns(): void {
    this.activeDropdown = null;
    this.showDriverFilter = false;
    this.showStatusFilter = false;
  }

  toggleDriverFilter() {
    this.showDriverFilter = !this.showDriverFilter;
    if (this.showDriverFilter) {
      this.getDriversForReassign();
    }
  }

  /**
   * Export orders
   */
  exportOrders(): void {
    // console.log('Exporting orders...');
    alert('Export functionality - to be implemented');
  }

  /**
   * Bulk actions
   */
  // bulkAssign(): void {
  //   console.log('Bulk assign:', this.selectedCount, 'orders');
  //   alert(`Assigning ${this.selectedCount} orders...`);
  // }
  async bulkAssign(): Promise<void> {
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    const label = ids.length === 1 ? 'order' : 'orders';

    const dialogResult = await this.dialogService.confirm(
      'Assign Orders',
      `Are you sure you want to assign ${label}?`,
      'Assign',
      'Cancel'
    );

    if (dialogResult?.confirmed) {
      const formdata = new FormData();
      formdata.append('order_ids', JSON.stringify(ids));
      formdata.append('driver_id', dialogResult.driverId);  // ✅ yahin se aa raha hai

      this.orderService.orderAssign(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) return;
          if (data.resultDescription) {
            this.toast.show('success', data.resultDescription);
          }
          this.clearSelection();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }


  async bulkUnassign(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Unassign Orders',
      `Are you sure you want to unassign ${label}?`,
      'Unassign',
      'Cancel'
    );

    if (!confirmed?.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderunAssign(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();

        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  async bulkRoute(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Route Orders',
      `Are you sure you want to route ${label}?`,
      'Route',
      'Cancel'
    );

    if (!confirmed.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderRoute(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();

        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }
  async bulkRefresh(): Promise<void> {
    // Get selected order IDs
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔹 SEQUENCE VALIDATION
    const selectedOrders = this.orders.filter((o: any) => o.selected);
    const expandedOrders = this.getExpandedValidationOrders(selectedOrders);
    const sequenceValid = this.isSequenceValid(expandedOrders);

    let confirmMessage = `Are you sure you want to refresh the ETA?`;

    const activeFilters = this.currentFilter.split(',').map((f: string) => f.trim());
    const isSequenceFilter = activeFilters.some((f: string) => f === 'pending' || f === 'assigned');
    if (!sequenceValid && isSequenceFilter) {
      confirmMessage += `<br><br><span style="color: #dd5d5d; font-weight: 700;">Note: The orders are not in right sequence.</span>`;
    }

    const confirmed = await this.dialogService.confirm(
      'Refresh ETA Orders',
      confirmMessage,
      'Refresh ETA',
      'Cancel'
    );

    if (!confirmed.confirmed) {
      return;
    }

    // Prepare FormData for API
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    formdata.append('refresh_eta', 'true');
    // console.log("FormData Value:", formdata.get('order_ids'));

    // API call for unassign
    this.orderService.orderRoute(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // Reset selection
        this.clearSelection();
        // this.fetchOrders();
        // // Refresh counts / stats
        // this.fetchOrderCounts();
        if (data.resultDescription) {
          this.toast.show('success', data.resultDescription);
        }

      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  bulkReassign(): void {
    console.log('Bulk reassign:', this.selectedCount, 'orders');
    alert(`Reassigning ${this.selectedCount} orders...`);
  }

  async bulkDelete(): Promise<void> {

    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);

    if (ids.length === 0) {
      this.toast.show('warning', 'Please select at least one order');
      return;
    }

    // 🔥 Singular / Plural message
    const label = ids.length === 1 ? 'order' : 'orders';

    const confirmed = await this.dialogService.confirm(
      'Delete Orders',
      `Are you sure you want to delete ${label}? This action cannot be undone.`,
      'Delete',
      'Cancel'
    );

    if (!confirmed?.confirmed) {
      return;
    }

    // API call
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    // console.log("FormData Value:", formdata.get('order_ids'));

    this.orderService.orderDelete(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) {
          return;
        }

        // 🔹 Instantly update local list and cache
        const deletedIdsSet = new Set(ids);
        this.orders = this.orders.filter((o: any) => !deletedIdsSet.has(o.id));
        this.allOrders = [...this.orders];
        localStorage.setItem('ordersCache', JSON.stringify(this.orders));


        // selection reset
        this.clearSelection();
        this.websocketRefresh.sendOrderListRequest({
          page: this.currentPage,
          page_size: 20,
          search_text: this.searchtext,
          order_date: this.orderDate,
          order_status: this.selectedStatuses,
          order_type: this.orderType,
          driver_ids: this.driverId
        });
        this.subscriptionRefresh =
          this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
            // this.handleRefreshData(data);
            if (data) {
              this.orders = (data.result.results || []).map((order: any) => {

                // 🔥 ETA hamesha array banane ka logic
                if (order.eta && !Array.isArray(order.eta)) {
                  // backend se object aa raha hai → array me convert
                  order.eta = [order.eta];
                }

                if (!order.eta) {
                  // null / undefined ho to empty array
                  order.eta = [];
                }

                return order;
              });
              this.totalOrders = data.result.count || 0;
              localStorage.setItem('ordersCache', JSON.stringify(this.orders));
              // console.log('this.orders',this.orders);
            }
          });
        this.updateSelectionCount();
        this.fetchOrderCounts();
        this.toast.show('success', data.resultDescription);
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
  }

  /**
   * Order actions
   */
  viewOrder(order: Order): void {
    console.log('View order:', order.id);
    alert(`Viewing order ${order.orderId}`);
  }

  editOrder(order: any): void {
    this.router.navigate(['admin/orders/edit', order.id]);
    // Implement edit functionality
  }

  trackOrder(order: Order): void {
    console.log('Track order:', order.id);
    alert(`Tracking order ${order.orderId}`);
  }

  // deleteOrder(order: Order): void {
  //   if (confirm(`Delete order ${order.orderId}?`)) {
  //     this.orders = this.orders.filter(o => o.id !== order.id);
  //     this.applyFilters();
  //   }
  // }
  async deleteOrder(orderId: any): Promise<void> {
    const confirmed = await this.dialogService.confirm(
      'Delete Row',
      'Are you sure you want to delete this row? This action cannot be undone.',
      'Delete',
      'Cancel'
    );

    if (confirmed?.confirmed) {
      var formdata = new FormData();
      formdata.append('order_ids', JSON.stringify([orderId]));
      // console.log("FormData Value:", formdata.get('order_ids'));
      this.orderService.orderDelete(formdata).subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }

          // 🔹 Instantly update local list and cache
          this.orders = this.orders.filter((o: any) => o.id !== orderId);
          this.allOrders = [...this.orders];
          localStorage.setItem('ordersCache', JSON.stringify(this.orders));

          // this.orderList();
          this.websocketRefresh.sendOrderListRequest({
            page: this.currentPage,
            page_size: 20,
            search_text: this.searchtext,
            order_date: this.orderDate,
            order_status: this.selectedStatuses,
            order_type: this.orderType,
            driver_ids: this.driverId
          });
          this.toast.show('success', data.resultDescription);
          this.subscriptionRefresh =
            this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
              // this.handleRefreshData(data);
              if (data) {
                this.orders = (data.result.results || []).map((order: any) => {

                  // 🔥 ETA hamesha array banane ka logic
                  if (order.eta && !Array.isArray(order.eta)) {
                    // backend se object aa raha hai → array me convert
                    order.eta = [order.eta];
                  }

                  if (!order.eta) {
                    // null / undefined ho to empty array
                    order.eta = [];
                  }

                  return order;
                });
                this.totalOrders = data.result.count || 0;
                localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                // console.log('this.orders',this.orders);
              }
            });
          this.updateSelectionCount();
          this.fetchOrderCounts();
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
    }
  }
  /**
   * Get status badge class
   */
  getStatusClass(status: string): string {
    return `status-badge ${status}`;
  }

  /**
   * Get filter count
   */
  getFilterCount(filter: string): number {
    switch (filter) {
      case 'all': return this.totalOrderscount;
      case 'pending': return this.pendingCount;
      case 'successful': return this.successfulCount;
      case 'unsuccessful': return this.unsuccessfulCount;
      case 'cancelled': return this.cancelledCount;
      default: return 0;
    }
  }

  hideTodaysDelivery = false;
  lastScrollTop = 0;

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   const scrollTop =
  //     window.pageYOffset || document.documentElement.scrollTop;

  //   // Scroll Down → Hide
  //   if (scrollTop > this.lastScrollTop && scrollTop > 120) {
  //     this.hideTodaysDelivery = true;
  //   }
  //   // Scroll Up → Show
  //   else {
  //     this.hideTodaysDelivery = false;
  //   }

  //   this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  // }
  @ViewChild('tableContainer', { static: false }) tableContainer!: ElementRef;
  goToOrderDetail(id: number | string): void {
    const scrollPos = this.tableContainer.nativeElement.scrollTop;
    localStorage.setItem('orderListScroll', scrollPos.toString());
    localStorage.setItem('fromOrderDetail', 'true');
    this.router.navigate(['/admin/orders/order-detail', id]);
  }
  formattedOrderIds(item: any): string {
    let ids = '';

    if (item?.order_type === 'pickup' && item?.pickup_multiple_order_ids) {
      ids = item.pickup_multiple_order_ids;
    } else if (item?.order_type === 'delivery' && item?.dely_multiple_order_ids) {
      ids = item.dely_multiple_order_ids;
    }
    else if (item?.order_type === 'pickup' && item?.dely_multiple_order_ids && item.parent_order != null) {
      ids = item.dely_multiple_order_ids;
    }

    return ids.replace(/,/g, ', ');
  }
  convertToLocalDate(utcDateString: string | null, isStacked: boolean = false): string {
    if (!utcDateString) {
      return '';
    }

    const datePipe = new DatePipe('en-US');
    const utcDate = new Date(utcDateString);
    const currentYear = new Date().getFullYear();

    if (utcDate.getFullYear() !== currentYear) {
      const dateStr = datePipe.transform(utcDate, 'EEE MMM dd') || '';
      const yearStr = datePipe.transform(utcDate, 'yyyy') || '';
      if (isStacked) {
        return `${dateStr}<br><span style="font-size: 11px; opacity: 0.85; font-weight: 500; display: block; margin-top: 1px;">${yearStr}</span>`;
      }
      return `${dateStr} ${yearStr}`;
    }

    return datePipe.transform(utcDate, 'EEE MMM dd') || '';
  }

  private getExpandedValidationOrders(selectedOrders: any[]): any[] {
    const expandedSet = new Set<any>();

    selectedOrders.forEach(clickedOrder => {
      const targetDriverId = clickedOrder.current_driver?.id;
      const targetStatus = clickedOrder.order_status;
      const isUnassigned = !targetDriverId;
      const targetDateStr = this.convertToLocalDate(clickedOrder.dely_date);

      const isMatch = (order: any): boolean => {
        const orderDriverId = order.current_driver?.id;
        const orderDateStr = this.convertToLocalDate(order.dely_date);
        const isStatusMatch = order.order_status === targetStatus;

        const needsDateCheck = isUnassigned || ['successful', 'unsuccessful', 'cancelled'].includes(targetStatus?.toLowerCase());

        if (needsDateCheck) {
          return (isUnassigned ? !orderDriverId : orderDriverId === targetDriverId) &&
            isStatusMatch &&
            orderDateStr === targetDateStr;
        } else {
          return orderDriverId === targetDriverId && isStatusMatch;
        }
      };

      this.orders.forEach((o: any) => {
        if (isMatch(o)) {
          expandedSet.add(o);
        }
      });
    });

    return Array.from(expandedSet);
  }

  private isSequenceValid(expandedOrders: any[]): boolean {
    const driverGroups: { [key: string]: any[] } = {};

    expandedOrders.forEach(order => {
      const driverId = order?.current_driver?.id;
      if (!driverId) return;
      if (!driverGroups[driverId]) driverGroups[driverId] = [];
      driverGroups[driverId].push(order);
    });

    for (const driverId in driverGroups) {
      const group = driverGroups[driverId];

      const ordersWithIndices = group.map(order => ({
        order,
        index: this.orders.findIndex((o: any) => o.id === order.id)
      })).sort((a, b) => a.index - b.index);

      const priorities = ordersWithIndices.map(item => {
        const o = item.order;
        const p = o.order_type === 'delivery' ? o.is_dely_first_delivery : o.is_pickup_first_delivery;
        return p ? Number(p) : null;
      }).filter((p): p is number => p !== null);

      for (let i = 0; i < priorities.length - 1; i++) {
        if (priorities[i] >= priorities[i + 1]) {
          return false;
        }
      }
    }

    return true;
  }

  convertTime24To12(val: any) {
    if (val != 'null' && val != '' && val) {
      let timeWithout00 = val.split(':');
      var time: any = timeWithout00[0] + ':' + timeWithout00[1];
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }

      return time.join('');
    }

  }
  getDriverInitials(driver: any): string {
    if (!driver || !driver.first_name || !driver.last_name) {
      return '';
    }

    const first = driver.first_name.charAt(0).toUpperCase();
    const last = driver.last_name.charAt(0).toUpperCase();

    return first + last;
  }
  getDriverDisplayName(driver: any): string {
    if (!driver || !driver.first_name) {
      return '';
    }

    const isVirtual = driver.is_virtual_user ||
      driver.first_name.toLowerCase().includes('truck') ||
      driver.first_name.toLowerCase().includes('zone') ||
      (driver.last_name && driver.last_name.toLowerCase().includes('truck')) ||
      (driver.last_name && driver.last_name.toLowerCase().includes('zone'));

    const hasNumbers = /\d/.test(driver.first_name) || (driver.last_name && /\d/.test(driver.last_name));

    if (isVirtual || hasNumbers) {
      return `${driver.first_name}${driver.last_name ? ' ' + driver.last_name : ''}`.trim();
    }

    // ---- Handle first name with multiple words ----
    const firstParts = driver.first_name.trim().split(' ');

    let name = this.capitalize(firstParts[0]); // first word full

    // baaki first name ke words ke initials
    for (let i = 1; i < firstParts.length; i++) {
      if (firstParts[i]) {
        name += ' ' + firstParts[i].charAt(0).toUpperCase();
      }
    }

    // ---- Middle name initial ----
    if (driver.middle_name) {
      name += ' ' + driver.middle_name.charAt(0).toUpperCase();
    }

    // ---- Last name initial ----
    if (driver.last_name) {
      name += ' ' + driver.last_name.charAt(0).toUpperCase();
    }

    return name;
  }

  capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
  userTimeZone: any;
  getUserTimeZone() {
    this.userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  formatETDA(etda: string): string {
    // Check if etda includes '-', if true, format the date, otherwise return etda
    if (etda.includes('-')) {
      const [datePart, timePart] = etda.split(' '); // Splitting date and time parts
      const [year, month, day] = datePart.split('-').map(part => parseInt(part));
      const [hour, minute, second] = timePart.split(':').map(part => parseFloat(part)); // using parseFloat for seconds to handle fractional seconds

      const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second)); // Creating Date object with UTC date and time
      const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: this.userTimeZone })); // Converting to local timezone dynamically

      return localDate.toLocaleString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
    } else {
      return etda;
    }
  }


  formatETDAs(item: any): string {
    // Check if "arrived" status is present in status history
    for (const statusItem of item.status_history) {
      if (statusItem.status === 'arrived') {
        // Extract the timestamp for "arrived" status
        const timestampUtc = statusItem.created_at;
        // Convert to Date object
        const dtObj = new Date(timestampUtc);
        // Convert to 12-hour format
        const timestamp12hr = dtObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        return timestamp12hr;
      }
    }
    return ''; // Return empty string if "arrived" status not found
  }
  shouldShowETA(item: any): boolean {
    if (!item || !item.order_status) return false;

    const validStatus = ['en-route', 'shipped', 'warehouse', 'pending'];

    return (
      validStatus.includes(item.order_status) &&
      item.eta &&
      item.eta.length > 0 &&
      item.eta[0] &&
      item.eta[0].etda
    );
  }
  shouldShowArrived(order: any): boolean {
    // Sirf current status arrived ho tabhi chale
    if (!order || order.order_status !== 'arrived') {
      return false;
    }

    // Aur status_history me arrived ka time hona chahiye
    if (order.status_history && order.status_history.length > 0) {
      return order.status_history.some((status: any) =>
        status.status === 'arrived' && status.created_at
      );
    }

    return false;
  }

  getColor(item: any | null): string {
    if (item === null || item.dely_time === undefined || item.order_status === undefined) {
      return 'black'; // Handle case where item or its properties are null or undefined
    }
    if (item.order_type == 'delivery') {
      var delyTime = this.convertTime24To12(item.dely_time);
    }
    if (item.order_type == 'pickup') {
      var delyTime = this.convertTime24To12(item.pickup_time);
    }
    if (!delyTime) {
      return 'black'; // Handle case where delyTime is null or undefined
    }

    const orderTime = this.getDateTime(item, item.order_status);
    if (!orderTime || orderTime === 'NA') {
      return 'black';
    }
    const datePipe = new DatePipe('en-US');
    const transformedDate = datePipe.transform(orderTime, 'shortTime');

    if (!transformedDate) {
      return 'black'; // Handle case where transformedDate is null
    }

    const [hours, minutes, period] = delyTime.split(/:| /);
    let hoursInt = parseInt(hours);
    let minutesInt = parseInt(minutes);
    minutesInt += 30;

    if (minutesInt >= 60) {
      hoursInt += Math.floor(minutesInt / 60);
      minutesInt %= 60;
    }

    let newPeriod = period;
    if (hoursInt >= 12) {
      if (period === "am") {
        newPeriod = "pm";
      } else {
        newPeriod = "am";
      }
    }

    const newDelyTime = `${hoursInt}:${minutesInt.toString().padStart(2, '0')} ${newPeriod}`;



    const newDelyTimeObj = new Date('2000-01-01 ' + newDelyTime);
    const transformedDateObj = new Date('2000-01-01 ' + transformedDate);

    return newDelyTimeObj < transformedDateObj ? 'red' : 'green';
  }
  getDateTime(item: any, status?: string) {
    var sitem = item?.status_history.find((item: any) => item.status === status);

    if (sitem) {
      return sitem.updated_at;
    } else {
      return "NA";
    }
  }
  getFirstPart(time: string | null): string | undefined {
    // Check if time is null, empty, or "0"
    if (!time || time.trim() === "0") {
      //console.error("Invalid time value:", time);
      return undefined;
    }

    // console.log(time);

    // Split the time string based on spaces
    const parts = time.split(" ");

    // Extract the numeric value and unit from the parts
    const value = parseFloat(parts[0]);
    const unit = parts[1].toLowerCase(); // Normalize to lowercase for comparison

    let minutes: number;

    // Convert hours to minutes if the unit is hour(s) or hr(s)
    if (unit === "hours" || unit === "hour" || unit === "hrs" || unit === "hr") {
      minutes = Math.floor(value * 60);
    }
    // Convert days to minutes if the unit is day(s)
    else if (unit === "days" || unit === "day") {
      minutes = Math.floor(value * 24 * 60);
    }
    // If the unit is already in minutes, return the value
    else if (unit === "minutes" || unit === "minute" || unit === "mins" || unit === "min") {
      minutes = Math.floor(value);
    }
    // If the unit is unknown, log an error and return undefined
    else {
      // console.error("Unknown time unit:", unit);
      return undefined;
    }

    return minutes.toString();
  }
  getTimeUnit(minutes: string | undefined): string {
    if (!minutes) {
      return '';
    }

    const timeValue = parseInt(minutes, 10);
    return timeValue === 1 ? 'min' : 'mins';
  }
  isChipActive(status: string): boolean {

    // agar niche se kuch bhi select nahi → All active
    if (this.selectedStatuses.length === 0) {
      return status === 'all';
    }

    // multiple selected → jo-jo selected wahi active
    return this.selectedStatuses.includes(status);
  }
  driverList: any;
  getDriversForReassign(): void {
    this.orderService.getActiveDriversForReassign('', '').subscribe({
      next: (res) => {
        if (res && res.result) {
          this.driverList = res.result.results;
        } else {
          this.driverList = [];
        }

        // console.log('Driver List:', this.driverList);
      },
      error: (err) => {
        console.error('Error while fetching drivers', err);
      }
    });
  }
  onDriverChange(driverId: any, event: any): void {
    const checked = event.target.checked;

    if (checked) {
      // checkbox select hua → add kar do
      if (!this.selectedDrivers.includes(driverId)) {
        this.selectedDrivers.push(driverId);
      }
    } else {
      // checkbox unselect hua → remove kar do
      this.selectedDrivers = this.selectedDrivers.filter(d => d !== driverId);
    }
    this.saveOrderListFiltersToLocalStorage();
    this.driverId = [...this.selectedDrivers];
    this.applyFilters();
  }
  saveOrderListFiltersToLocalStorage() {
    const filters = {
      orderDate: this.orderDate,
      selectedDrivers: this.selectedDrivers,
      selectedStatuses: this.selectedStatuses,
      searchText: this.searchtext,
      orderType: this.orderType,
      // aur bhi filter ho toh yahan add karein
    };
    localStorage.setItem('orderListFilters', JSON.stringify(filters));
  }
  getCurrentUrl: string = '';
  getPreviousUrl: string = '';
  restoreOrderListFiltersFromLocalStorage() {
    const filters = localStorage.getItem('orderListFilters');
    if (filters) {
      const parsed = JSON.parse(filters);
      this.orderDate = parsed.orderDate || '';
      this.selectedDrivers = parsed.selectedDrivers || [];
      this.selectedStatuses = parsed.selectedStatuses || [''];
      this.searchtext = parsed.searchText || '';
      this.orderType = parsed.orderType || null;
      this.driverId = [...this.selectedDrivers];
      this.currentFilter = this.selectedStatuses.length > 0 ? this.selectedStatuses.join(',') : 'all';

      // aur bhi filter ho toh yahan restore karein
    }
    this.nextPageUrl = localStorage.getItem('nextPageUrl');
    const rawUrl = localStorage.getItem('nextPageUrl');

    if (rawUrl && rawUrl !== 'null' && rawUrl !== '""') {
      // 🔹 Remove extra quotes if present
      const cleanUrl = rawUrl.replace(/"/g, '');

      const match = cleanUrl.match(/page=(\d+)/);
      if (match) {
        this.currentPage = Number(match[1]) - 1; // 0-based adjust
      }
    }

    localStorage.setItem('getCurrentUrl', this.navigationService.getCurrentUrl());
    localStorage.setItem('getPreviousUrl', this.navigationService.getPreviousUrl());
    this.getCurrentUrl = localStorage.getItem('getCurrentUrl') || '';
    this.getPreviousUrl = localStorage.getItem('getPreviousUrl') || '';
  }
  removeOrderListFiltersFromLocalStorage() {
    localStorage.removeItem('orderListFilters');
  }
  restoreOrdersFromCache(): boolean {
    const cachedOrders = localStorage.getItem('ordersCache');
    const cachedScroll = localStorage.getItem('orderListScroll');
    if (!cachedOrders) return false;
    // :small_blue_diamond: restore orders
    this.orders = JSON.parse(cachedOrders);
    const updatedOrder = localStorage.getItem('updatedOrder');
    if (updatedOrder) {
      const updatedObj = JSON.parse(updatedOrder);
      const index = this.orders.findIndex((o: any) => o.id === updatedObj.id);
      if (index !== -1) {
        this.orders[index] = { ...this.orders[index], ...updatedObj };
      }
      localStorage.setItem('ordersCache', JSON.stringify(this.orders));
      localStorage.removeItem('updatedOrder');
    }

    this.allOrders = [...this.orders];   // :fire: VERY IMPORTANT
    this.totalOrders = this.orders.length;
    // this.fetchOrderCounts();
    // :small_blue_diamond: force table render first
    // :small_blue_diamond: scroll restore AFTER view is fully ready
    if (cachedScroll) {
      setTimeout(() => {
        if (this.tableContainer) {
          this.tableContainer.nativeElement.scrollTop = +cachedScroll;
        }
      }, 50);   // :fire: small delay = magic
    }
    return true;
  }
  dropIndex: any;
  dragdrivername: any;
  prioritystart: boolean = false;
  priorityStarts: boolean = false;
  onDrop(event: CdkDragDrop<any[]>) {
    const pendingOrders = this.orders.filter((order: { order_status: string; }) => order.order_status === 'pending');

    const groupedOrders = pendingOrders.reduce((acc: { withDriver: { [x: string]: any[]; }; noDriver: any[]; }, order: { current_driver: { id: any; }; }) => {
      if (order.current_driver && order.current_driver.id) {
        const driverId = order.current_driver.id;
        if (!acc.withDriver[driverId]) {
          acc.withDriver[driverId] = [];
        }
        acc.withDriver[driverId].push(order);
      } else {
        acc.noDriver.push(order);
      }
      return acc;
    }, { withDriver: {}, noDriver: [] });

    console.log(groupedOrders);

    const draggedIndex = event.previousIndex;
    this.dropIndex = event.currentIndex;
    this.dragdrivername = event.item.data.current_driver.first_name + ' ' + event.item.data.current_driver.last_name

    // Get the driver ID of the dragged item
    const draggedDriverId = this.orders[draggedIndex]?.current_driver?.id;
    const draggedDriverStatus = this.orders[draggedIndex]?.order_status

    // Get the driver ID of the drop item
    const dropDriverId = this.orders[this.dropIndex]?.current_driver?.id;
    const dropDriverStatus = this.orders[this.dropIndex]?.order_status

    if (draggedDriverStatus == "pending" && dropDriverStatus == "pending") {
      // Check if the dragged item belongs to the same driver group as the drop item
      if (draggedDriverId && dropDriverId && draggedDriverId === dropDriverId) {
        // Dragged item belongs to the same driver group as the drop item
        const conditionForSameDriverGroup = 'Dragged item belongs to the same driver group as the drop item'/* your condition for same driver group */;
        console.log('Condition for same driver group: Dragged item belongs to the same driver group as the drop item', conditionForSameDriverGroup);

        const selectedItem = this.orders[this.dropIndex];
        console.log('Selected Item:', selectedItem);


        if (selectedItem && selectedItem.id) {
          const selectedItemId = selectedItem.id;

          let isInWithDriver = false;
          let driverGroupKey = null;
          let driverGroupIndex = -1;

          // Check in withDriver group
          for (const driverId in groupedOrders.withDriver) {
            const driverGroup = groupedOrders.withDriver[driverId];
            const index = driverGroup.findIndex((order: { id: any; }) => order.id === selectedItemId);
            if (index !== -1) {
              isInWithDriver = true;
              driverGroupKey = driverId;
              driverGroupIndex = index;
              break;
            }
          }

          // Check in noDriver group
          const noDriverIndex = groupedOrders.noDriver.findIndex((order: { id: any; }) => order.id === selectedItemId);
          const isInNoDriver = noDriverIndex !== -1;

          if (isInWithDriver) {
            console.log(`Selected item is in withDriver group with driverId: ${driverGroupKey} at index: ${driverGroupIndex}`);
            const driverGroupIndexStored = driverGroupIndex;
            const storedDriverCount = localStorage.getItem(`withDriverCount_${driverGroupKey}`);
            const driverCount = storedDriverCount ? parseInt(storedDriverCount, 10) || 0 : 0;
            const formatDate = (isoString: string): string => {
              const datePipe = new DatePipe('en-US'); // Create an instance of DatePipe
              const localDate = new Date(isoString); // Convert UTC date to local time
              return datePipe.transform(localDate, 'yyyy-MM-dd') || ''; // Format the date in 'YYYY-MM-DD' format
            };

            const draggedItemDate = formatDate(this.orders[draggedIndex].dely_date);
            const dropLocationDate = formatDate(this.orders[this.dropIndex].dely_date);
            const todayDate = formatDate(new Date().toISOString());
            const formatDates = (isoString: string): string => isoString.split('T')[0];
            const droplocationutcDates = this.orders[this.dropIndex].dely_date
            let message = '';
            if (
              new Date(draggedItemDate).toDateString() === new Date(todayDate).toDateString() &&
              new Date(dropLocationDate) > new Date(todayDate)
            ) {
              const fromDateStr = this.convertToLocalDate(this.orders[draggedIndex].dely_date);
              const toDateStr = this.convertToLocalDate(this.orders[this.dropIndex].dely_date);
              message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
              // message = 'You are attempting to update a current date order to a future date. Do you want to continue and update to the future date?';
            } else if (
              new Date(draggedItemDate) > new Date(todayDate) &&
              new Date(dropLocationDate).toDateString() === new Date(todayDate).toDateString()
            ) {
              const fromDateStr = this.convertToLocalDate(this.orders[draggedIndex].dely_date);
              const toDateStr = this.convertToLocalDate(this.orders[this.dropIndex].dely_date);
              message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
              // message = 'You are attempting to update a future date order to the current date. Do you want to continue and update to the current date?';
            } else if (
              new Date(draggedItemDate) < new Date(todayDate) &&
              new Date(dropLocationDate).toDateString() === new Date(todayDate).toDateString()
            ) {
              const fromDateStr = this.convertToLocalDate(this.orders[draggedIndex].dely_date);
              const toDateStr = this.convertToLocalDate(this.orders[this.dropIndex].dely_date);
              message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
              // message = 'You are attempting to update a past date order to the current date. Do you want to continue and update to the current date?';
            }
            else if (
              new Date(draggedItemDate) > new Date(todayDate) &&
              new Date(dropLocationDate) > new Date(todayDate) && new Date(draggedItemDate).getTime() !== new Date(dropLocationDate).getTime()
            ) {
              const fromDateStr = this.convertToLocalDate(this.orders[draggedIndex].dely_date);
              const toDateStr = this.convertToLocalDate(this.orders[this.dropIndex].dely_date);
              message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
              // message = 'You are attempting to update a future date order to another future date. Do you want to continue and update to the new future date?';
            }

            // else if (
            //   new Date(draggedItemDate) < new Date(todayDate) && 
            //   new Date(dropLocationDate) < new Date(todayDate) &&
            //   new Date(draggedItemDate).getTime() !== new Date(dropLocationDate).getTime()
            // ) {
            //   // ✅ New condition: allow past → past
            //   const fromDateStr = this.convertToLocalDate(this.orderData[draggedIndex].dely_date);
            //   const toDateStr = this.convertToLocalDate(this.orderData[this.dropIndex].dely_date);
            //   message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
            //    // message = 'You are attempting to update a past date order to another past date. Do you want to continue and update to the new future date?';
            // }

            // if (message) {
            //     // Show confirmation dialog with the appropriate message
            //     const dialogRef = this.dialog.open(AppConfirmationDialogComponent, {
            //         width: '450px',
            //         data: { message }
            //     });

            //     dialogRef.afterClosed().subscribe(result => {
            //         if (result === 'confirm') {
            //             // If user confirms, update the order's date in the backend first
            //             const updateDateFormData = new FormData();
            //             updateDateFormData.append('date', droplocationutcDates);

            //             this.orderService.updateOrderDate(this.idsss, updateDateFormData).subscribe(
            //                 (response) => {
            //                     if (response.resultCode == '1') {
            //                         this.toastr.success(response.resultDescription);
            //                         this.fetchOrders();
            //                          this.fetchOrderCounts();
            //                         // this.orderService.getSearchText().subscribe((res) => {
            //                         //     if (res && res.length > 0) {
            //                         //         this.orderList(this.orderDate, this.orderType, this.orderStatus, this.page, res, this.selectedDriver);
            //                         //     } else {
            //                         //         this.orderList(this.orderDate, this.orderType, this.orderStatus, this.page, '', this.selectedDriver);
            //                         //     }
            //                         // });
            //                     } else if (response.resultCode == '0') {
            //                         this.toastr.error('Failed to update order date');
            //                     }
            //                 },
            //                 () => {
            //                     this.toastr.error('Failed to update order date');
            //                 }
            //             );
            //         }
            //     });
            // }
            if (message) {
              // Use async IIFE so we can use await inside
              (async () => {
                const confirmed = await this.dialogService.confirm(
                  'Update Order Date',
                  message,
                  'Update',
                  'Cancel'
                );

                if (confirmed.confirmed) {
                  const updateDateFormData = new FormData();
                  updateDateFormData.append('date', droplocationutcDates);

                  this.orderService.updateOrderDate(this.idsss, updateDateFormData).subscribe(
                    (response) => {
                      if (response.resultCode === '1') {
                        this.toast.show('success', response.resultDescription);
                        this.websocketRefresh.sendOrderListRequest({
                          page: this.currentPage,
                          page_size: 20,
                          search_text: this.searchtext,
                          order_date: this.orderDate,
                          order_status: this.selectedStatuses,
                          order_type: this.orderType,
                          driver_ids: this.driverId
                        });
                        this.subscriptionRefresh =
                          this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                            // this.handleRefreshData(data);
                            if (data) {
                              this.orders = (data.result.results || []).map((order: any) => {

                                // 🔥 ETA hamesha array banane ka logic
                                if (order.eta && !Array.isArray(order.eta)) {
                                  // backend se object aa raha hai → array me convert
                                  order.eta = [order.eta];
                                }

                                if (!order.eta) {
                                  // null / undefined ho to empty array
                                  order.eta = [];
                                }

                                return order;
                              });
                              this.totalOrders = data.result.count || 0;
                              localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                              // console.log('this.orders',this.orders);
                            }
                          });
                        this.updateSelectionCount();
                        this.fetchOrderCounts();
                      } else {
                        this.toast.show('error', 'Failed to update order date');
                      }
                    },
                    (error) => {
                      this.toast.show('error', 'Failed to update order date');
                    }
                  );
                }
              })();
            }




            if (this.currentPage >= 0) {
              let count = 0;
              const formData = new FormData();
              this.dropIndex = this.dropIndex;
              formData.append('order_id', this.idsss);
              formData.append('priority', ((driverGroupIndexStored + 1)).toString());
              this.orderService.orderPriority(formData).subscribe(
                (data: any) => {
                  if (this.authService.resultCodeError(data)) {
                    return;
                  }
                  this.toast.show('success', data.result);

                  localStorage.setItem('c', '0');
                  var storedData = localStorage.getItem('pageIndex');
                  this.websocketRefresh.sendOrderListRequest({
                    page: this.currentPage,
                    page_size: 20,
                    search_text: this.searchtext,
                    order_date: this.orderDate,
                    order_status: this.selectedStatuses,
                    order_type: this.orderType,
                    driver_ids: this.driverId
                  });
                  this.subscriptionRefresh =
                    this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                      // this.handleRefreshData(data);
                      if (data) {
                        this.orders = (data.result.results || []).map((order: any) => {

                          // 🔥 ETA hamesha array banane ka logic
                          if (order.eta && !Array.isArray(order.eta)) {
                            // backend se object aa raha hai → array me convert
                            order.eta = [order.eta];
                          }

                          if (!order.eta) {
                            // null / undefined ho to empty array
                            order.eta = [];
                          }

                          return order;
                        });
                        this.totalOrders = data.result.count || 0;
                        localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                        // console.log('this.orders',this.orders);
                      }
                    });
                  this.updateSelectionCount();
                  this.fetchOrderCounts();
                  // this.orderCount();
                  // this.orderService.getSearchText().subscribe((res)=>{
                  //   if(res && res.length > 0){
                  //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res,this.selectedDriver);
                  //   } else{
                  //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,'',this.selectedDriver)
                  //   }
                  // })
                  moveItemInArray(this.orders, draggedIndex, this.dropIndex);

                },
                (error) => {
                  this.authService.dataError(error);
                }
              );

            }
            // if(this.page >0){
            //   let count =0 ;
            //   const formData = new FormData();
            //   this.dropIndex =this.dropIndex;
            //   formData.append('order_id', this.idsss);
            //   formData.append('priority', ((driverGroupIndexStored+1 +driverCount)).toString());
            //   this.orderService.orderPriority(formData).subscribe(
            //     (data: any) => {
            //         if (this.authService.resultCodeError(data)) {
            //             this.loading = false;
            //             return;
            //         }
            //         this.toastr.success(data?.result);
            //         localStorage.setItem('c','0');
            //         var storedData = localStorage.getItem('pageIndex');
            //         this.page=Number(storedData)
            //           // this.orderCount();
            //           // this.orderService.getSearchText().subscribe((res)=>{
            //           //   if(res && res.length > 0){
            //           //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res,this.selectedDriver);
            //           //   } else{
            //           //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,'',this.selectedDriver)
            //           //   }
            //           // })
            //            const driverIds = this.selectedDriver.map(driverId => Number(driverId));
            //                         this.orderList1(this.searchtext, this.orderDate, this.selectedStatuss, this.orderType, driverIds, this.page);
            //                         this.orderCount(this.orderDate, this.orderType, this.selectedDriver, this.selectedStatuss, 	 this.searchtext)
            //         moveItemInArray(this.orderData, draggedIndex, this.dropIndex);

            //         this.loading = false;
            //     },
            //     (error) => {
            //         this.authService.dataError(error);
            //         this.loading = false;
            //     }
            // );

            // }
          } else if (isInNoDriver) {
            console.log(`Selected item is in noDriver group at index: ${noDriverIndex}`);
            const noDriverIndexStored = noDriverIndex;
            if (this.currentPage == 0) {
              let count = 0;
              const formData = new FormData();
              this.dropIndex = this.dropIndex;
              formData.append('order_id', this.idsss);
              formData.append('priority', ((noDriverIndexStored + 1)).toString());
              this.orderService.orderPriority(formData).subscribe(
                (data: any) => {
                  if (this.authService.resultCodeError(data)) {
                    return;
                  }
                  this.toast.show('success', data.result);
                  localStorage.setItem('c', '0');
                  var storedData = localStorage.getItem('pageIndex');
                  this.websocketRefresh.sendOrderListRequest({
                    page: this.currentPage,
                    page_size: 20,
                    search_text: this.searchtext,
                    order_date: this.orderDate,
                    order_status: this.selectedStatuses,
                    order_type: this.orderType,
                    driver_ids: this.driverId
                  });
                  this.subscriptionRefresh =
                    this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                      // this.handleRefreshData(data);
                      if (data) {
                        this.orders = (data.result.results || []).map((order: any) => {

                          // 🔥 ETA hamesha array banane ka logic
                          if (order.eta && !Array.isArray(order.eta)) {
                            // backend se object aa raha hai → array me convert
                            order.eta = [order.eta];
                          }

                          if (!order.eta) {
                            // null / undefined ho to empty array
                            order.eta = [];
                          }

                          return order;
                        });
                        this.totalOrders = data.result.count || 0;
                        localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                        // console.log('this.orders',this.orders);
                      }
                    });
                  this.updateSelectionCount();
                  this.fetchOrderCounts();
                  // this.orderCount();
                  // this.orderService.getSearchText().subscribe((res)=>{
                  //   if(res && res.length > 0){
                  //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res,this.selectedDriver);
                  //   } else{
                  //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,'',this.selectedDriver)
                  //   }
                  // })
                  moveItemInArray(this.orders, draggedIndex, this.dropIndex);


                },
                (error) => {
                  this.authService.dataError(error);
                }
              );

            }
          } else {
            console.log('Selected item is not found in groupedOrders');
          }
        } else {
          console.error('Selected item does not have an id');
        }
      } else if (draggedDriverId && !dropDriverId) {
        // Dragged item has a driver ID but drop item has no driver ID
        const conditionForDraggedWithDriverAndDropNoDriver = 'Dragged item has a driver ID but drop item has no driver ID' /* your condition for dragged with driver and drop no driver */;
        console.log('Condition for dragged with driver and drop no driver: Dragged item has a driver ID but drop item has no driver ID', conditionForDraggedWithDriverAndDropNoDriver);

        let enterAnimationDuration = '200ms';
        let exitAnimationDuration = '200ms';

        const orderNumber = this.orders[draggedIndex]?.order_no || this.orders[draggedIndex]?.po;

        // Wrap in async IIFE to use await
        (async () => {
          const confirmed = await this.dialogService.confirm(
            'Alert?',
            'Are you sure you want to Unassign this Order?',
            'Unassign Order',
            'Cancel'
          );

          if (!confirmed.confirmed) return;

          // User confirmed, proceed with unassign
          const formdata = new FormData();
          formdata.append('order_ids', JSON.stringify([Number(this.idsss)]));

          this.orderService.orderunAssign(formdata).subscribe(
            (data: any) => {
              if (this.authService.resultCodeError(data)) return;

              this.toast.show('success', data.resultDescription);
              this.prioritystart = true;

              if (this.prioritystart) {
                this.prioritystart = false;
                const selectedItem = this.orders[this.dropIndex];
                console.log('Selected Item:', selectedItem);

                if (selectedItem && selectedItem.id) {
                  const selectedItemId = selectedItem.id;

                  let isInWithDriver = false;
                  let driverGroupKey = null;
                  let driverGroupIndex = -1;

                  // Check in withDriver group
                  for (const driverId in groupedOrders.withDriver) {
                    const driverGroup = groupedOrders.withDriver[driverId];
                    const index = driverGroup.findIndex(
                      (order: { id: any }) => order.id === selectedItemId
                    );
                    if (index !== -1) {
                      isInWithDriver = true;
                      driverGroupKey = driverId;
                      driverGroupIndex = index;
                      break;
                    }
                  }

                  // Check in noDriver group
                  const noDriverIndex = groupedOrders.noDriver.findIndex(
                    (order: { id: any }) => order.id === selectedItemId
                  );
                  const isInNoDriver = noDriverIndex !== -1;

                  if (isInWithDriver) {
                    const driverGroupIndexStored = driverGroupIndex;
                    if (this.currentPage == 0) {
                      const formData = new FormData();
                      formData.append('order_id', this.idsss);
                      formData.append(
                        'priority',
                        (driverGroupIndexStored + 1).toString()
                      );

                      this.orderService.orderPriority(formData).subscribe(
                        (data: any) => {
                          if (this.authService.resultCodeError(data)) return;

                          this.toast.show('success', data.result);
                          this.websocketRefresh.sendOrderListRequest({
                            page: this.currentPage,
                            page_size: 20,
                            search_text: this.searchtext,
                            order_date: this.orderDate,
                            order_status: this.selectedStatuses,
                            order_type: this.orderType,
                            driver_ids: this.driverId
                          });
                          this.subscriptionRefresh =
                            this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                              // this.handleRefreshData(data);
                              if (data) {
                                this.orders = (data.result.results || []).map((order: any) => {

                                  // 🔥 ETA hamesha array banane ka logic
                                  if (order.eta && !Array.isArray(order.eta)) {
                                    // backend se object aa raha hai → array me convert
                                    order.eta = [order.eta];
                                  }

                                  if (!order.eta) {
                                    // null / undefined ho to empty array
                                    order.eta = [];
                                  }

                                  return order;
                                });
                                this.totalOrders = data.result.count || 0;
                                localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                // console.log('this.orders',this.orders);
                              }
                            });
                          this.updateSelectionCount();
                          this.fetchOrderCounts();
                          moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                        },
                        (error) => {
                          this.authService.dataError(error);
                        }
                      );
                    }
                  } else if (isInNoDriver) {
                    const noDriverIndexStored = noDriverIndex;
                    const storedDriverCount = localStorage.getItem(`noDriverCount`);
                    const driverCount = storedDriverCount
                      ? parseInt(storedDriverCount, 10) || 0
                      : 0;

                    if (this.currentPage >= 0) {
                      const formData = new FormData();
                      formData.append('order_id', this.idsss);
                      formData.append(
                        'priority',
                        (noDriverIndexStored + 1).toString()
                      );

                      this.orderService.orderPriority(formData).subscribe(
                        (data: any) => {
                          if (this.authService.resultCodeError(data)) return;

                          this.toast.show('success', data.result);
                          localStorage.setItem('c', '0');
                          this.websocketRefresh.sendOrderListRequest({
                            page: this.currentPage,
                            page_size: 20,
                            search_text: this.searchtext,
                            order_date: this.orderDate,
                            order_status: this.selectedStatuses,
                            order_type: this.orderType,
                            driver_ids: this.driverId
                          });
                          this.subscriptionRefresh =
                            this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                              // this.handleRefreshData(data);
                              if (data) {
                                this.orders = (data.result.results || []).map((order: any) => {

                                  // 🔥 ETA hamesha array banane ka logic
                                  if (order.eta && !Array.isArray(order.eta)) {
                                    // backend se object aa raha hai → array me convert
                                    order.eta = [order.eta];
                                  }

                                  if (!order.eta) {
                                    // null / undefined ho to empty array
                                    order.eta = [];
                                  }

                                  return order;
                                });
                                this.totalOrders = data.result.count || 0;
                                localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                // console.log('this.orders',this.orders);
                              }
                            });
                          this.updateSelectionCount();
                          this.fetchOrderCounts();
                          moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                        },
                        (error) => {
                          this.authService.dataError(error);
                        }
                      );
                    }
                  } else {
                    console.log('Selected item is not found in groupedOrders');
                  }
                } else {
                  console.error('Selected item does not have an id');
                }
              }
            },
            (error) => {
              this.authService.dataError(error);
            }
          );
        })();






      } else {
        // Check if the dragged item has no driver
        if (!draggedDriverId) {
          // Dragged item has no driver
          const conditionForNoDriver = 'Dragged item has no driver' /* your condition for no driver */;
          console.log('Condition for no driver:', conditionForNoDriver);

          const conditionForSameDriverGroup = 'Dragged item belongs to the same driver group as the drop item'/* your condition for same driver group */;
          console.log('Condition for same driver group: Dragged item belongs to the same driver group as the drop item', conditionForSameDriverGroup);

          const selectedItem = this.orders[this.dropIndex];
          console.log('Selected Item:', selectedItem);


          if (selectedItem && selectedItem.id) {
            const selectedItemId = selectedItem.id;

            let isInWithDriver = false;
            let driverGroupKey = null;
            let driverGroupIndex = -1;

            // Check in withDriver group
            for (const driverId in groupedOrders.withDriver) {
              const driverGroup = groupedOrders.withDriver[driverId];
              const index = driverGroup.findIndex((order: { id: any; }) => order.id === selectedItemId);
              if (index !== -1) {
                isInWithDriver = true;
                driverGroupKey = driverId;
                driverGroupIndex = index;
                break;
              }
            }

            // Check in noDriver group
            const noDriverIndex = groupedOrders.noDriver.findIndex((order: { id: any; }) => order.id === selectedItemId);
            const isInNoDriver = noDriverIndex !== -1;

            if (isInWithDriver) {
              console.log(`Selected item is in withDriver group with driverId: ${driverGroupKey} at index: ${driverGroupIndex}`);
              const driverGroupIndexStored = driverGroupIndex;
              const noDriverId = dropDriverId;
              let driverName = 'Driver not found';
              this.orders.forEach((order: { current_driver: { id: any; first_name: any; last_name: any; }; }) => {
                if (order.current_driver.id === noDriverId) {
                  driverName = order.current_driver.first_name + " " + order.current_driver.last_name;
                }
              });

              let enterAnimationDuration = '200ms';
              let exitAnimationDuration = '200ms';
              const orderNumber = this.orders[draggedIndex]?.order_no || this.orders[draggedIndex]?.po;

              // Inline async IIFE to use await
              (async () => {
                const confirmed = await this.dialogService.confirm(
                  'Alert?',
                  `Are you sure you want to assign this order to ${driverName}?`,
                  'Assign Order',
                  'Cancel'
                );

                if (!confirmed.confirmed) return;

                // User confirmed — proceed with assign
                const formdata = new FormData();
                formdata.append('order_ids', JSON.stringify([Number(this.idsss)]));
                formdata.append('driver_id', noDriverId);

                this.orderService.orderAssign(formdata).subscribe(
                  (data: any) => {
                    if (this.authService.resultCodeError(data)) return;

                    this.toast.show('success', data.resultDescription);
                    this.priorityStarts = true;

                    if (this.priorityStarts) {
                      this.priorityStarts = false;
                      const selectedItem = this.orders[this.dropIndex];

                      if (selectedItem && selectedItem.id) {
                        const selectedItemId = selectedItem.id;

                        let isInWithDriver = false;
                        let driverGroupKey = null;
                        let driverGroupIndex = -1;

                        // Check in withDriver group
                        for (const driverId in groupedOrders.withDriver) {
                          const driverGroup = groupedOrders.withDriver[driverId];
                          const index = driverGroup.findIndex(
                            (order: { id: any }) => order.id === selectedItemId
                          );
                          if (index !== -1) {
                            isInWithDriver = true;
                            driverGroupKey = driverId;
                            driverGroupIndex = index;
                            break;
                          }
                        }

                        // Check in noDriver group
                        const noDriverIndex = groupedOrders.noDriver.findIndex(
                          (order: { id: any }) => order.id === selectedItemId
                        );
                        const isInNoDriver = noDriverIndex !== -1;

                        if (isInWithDriver) {
                          const driverGroupIndexStored = driverGroupIndex;
                          if (this.currentPage >= 0) {
                            const formData = new FormData();
                            formData.append('order_id', this.idsss);
                            formData.append('priority', (driverGroupIndexStored + 1).toString());

                            this.orderService.orderPriority(formData).subscribe(
                              (data: any) => {
                                if (this.authService.resultCodeError(data)) return;

                                this.toast.show('success', data.result);
                                localStorage.setItem('c', '0');
                                this.websocketRefresh.sendOrderListRequest({
                                  page: this.currentPage,
                                  page_size: 20,
                                  search_text: this.searchtext,
                                  order_date: this.orderDate,
                                  order_status: this.selectedStatuses,
                                  order_type: this.orderType,
                                  driver_ids: this.driverId
                                });
                                this.subscriptionRefresh =
                                  this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                                    // this.handleRefreshData(data);
                                    if (data) {
                                      this.orders = (data.result.results || []).map((order: any) => {

                                        // 🔥 ETA hamesha array banane ka logic
                                        if (order.eta && !Array.isArray(order.eta)) {
                                          // backend se object aa raha hai → array me convert
                                          order.eta = [order.eta];
                                        }

                                        if (!order.eta) {
                                          // null / undefined ho to empty array
                                          order.eta = [];
                                        }

                                        return order;
                                      });
                                      this.totalOrders = data.result.count || 0;
                                      localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                      // console.log('this.orders',this.orders);
                                    }
                                  });
                                this.updateSelectionCount();
                                this.fetchOrderCounts();
                                moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                              },
                              (error) => this.authService.dataError(error)
                            );
                          }
                        } else if (isInNoDriver) {
                          const noDriverIndexStored = noDriverIndex;
                          if (this.currentPage >= 0) {
                            const formData = new FormData();
                            formData.append('order_id', this.idsss);
                            formData.append('priority', (noDriverIndexStored + 1).toString());

                            this.orderService.orderPriority(formData).subscribe(
                              (data: any) => {
                                if (this.authService.resultCodeError(data)) return;

                                this.toast.show('success', data.result);
                                localStorage.setItem('c', '0');
                                this.websocketRefresh.sendOrderListRequest({
                                  page: this.currentPage,
                                  page_size: 20,
                                  search_text: this.searchtext,
                                  order_date: this.orderDate,
                                  order_status: this.selectedStatuses,
                                  order_type: this.orderType,
                                  driver_ids: this.driverId
                                });
                                this.subscriptionRefresh =
                                  this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                                    // this.handleRefreshData(data);
                                    if (data) {
                                      this.orders = (data.result.results || []).map((order: any) => {

                                        // 🔥 ETA hamesha array banane ka logic
                                        if (order.eta && !Array.isArray(order.eta)) {
                                          // backend se object aa raha hai → array me convert
                                          order.eta = [order.eta];
                                        }

                                        if (!order.eta) {
                                          // null / undefined ho to empty array
                                          order.eta = [];
                                        }

                                        return order;
                                      });
                                      this.totalOrders = data.result.count || 0;
                                      localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                      // console.log('this.orders',this.orders);
                                    }
                                  });
                                this.updateSelectionCount();
                                this.fetchOrderCounts();
                                moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                              },
                              (error) => this.authService.dataError(error)
                            );
                          }
                        } else {
                          console.log('Selected item is not found in groupedOrders');
                        }
                      } else {
                        console.error('Selected item does not have an id');
                      }
                    }
                  },
                  (error) => this.authService.dataError(error)
                );
              })();




              // if(this.page ==0){
              //   let count =0 ;
              //   const formData = new FormData();
              //   this.dropIndex =this.dropIndex;
              //   formData.append('order_id', this.idsss);
              //   formData.append('priority', ((driverGroupIndexStored+1)).toString());
              //   this.orderService.orderPriority(formData).subscribe(
              //     (data: any) => {
              //         if (this.authService.resultCodeError(data)) {
              //             this.loading = false;
              //             return;
              //         }
              //         this.toastr.success(data?.result);
              //         localStorage.setItem('c','0');
              //         var storedData = localStorage.getItem('pageIndex');
              //         this.page=Number(storedData)
              //           this.orderCount();
              //           this.orderService.getSearchText().subscribe((res)=>{
              //             if(res && res.length > 0){
              //               this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res);
              //             } else{
              //               this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page)
              //             }
              //           })
              //         moveItemInArray(this.orderData, draggedIndex, this.dropIndex);

              //         this.loading = false;
              //     },
              //     (error) => {
              //         this.authService.dataError(error);
              //         this.loading = false;
              //     }
              // );

              // }
            } else if (isInNoDriver) {
              console.log(`Selected item is in noDriver group at index: ${noDriverIndex}`);
              const noDriverIndexStored = noDriverIndex;
              const storedDriverCount = localStorage.getItem(`noDriverCount`);
              const driverCount = storedDriverCount ? parseInt(storedDriverCount, 10) || 0 : 0;
              const formatDate = (isoString: string): string => {
                const datePipe = new DatePipe('en-US'); // Create an instance of DatePipe
                const localDate = new Date(isoString); // Convert UTC date to local time
                return datePipe.transform(localDate, 'yyyy-MM-dd') || ''; // Format the date in 'YYYY-MM-DD' format
              };
              const draggedItemDate = formatDate(this.orders[draggedIndex].dely_date);
              const dropLocationDate = formatDate(this.orders[this.dropIndex].dely_date);
              const droplocationutcDates = this.orders[this.dropIndex].dely_date
              const todayDate = formatDate(new Date().toISOString());
              let message = '';

              if (
                new Date(draggedItemDate).toDateString() != new Date(dropLocationDate).toDateString() && new Date(dropLocationDate) >= new Date(todayDate)
              ) {
                const fromDateStr = this.convertToLocalDate(this.orders[draggedIndex].dely_date);
                const toDateStr = this.convertToLocalDate(this.orders[this.dropIndex].dely_date);
                message = `Are you sure you want to change the date from <b>${fromDateStr}</b> to <b>${toDateStr}</b>?`;
              }
              if (message) {
                // Inline async IIFE to use await
                (async () => {
                  const confirmed = await this.dialogService.confirm(
                    'Update Order Date',
                    message,
                    'Update',
                    'Cancel'
                  );

                  if (!confirmed.confirmed) return;

                  // User confirmed — proceed with updating order date
                  const updateDateFormData = new FormData();
                  updateDateFormData.append('date', droplocationutcDates);

                  this.orderService.updateOrderDate(this.idsss, updateDateFormData).subscribe(
                    (response) => {
                      if (response.resultCode === '1') {
                        this.toast.show('success', response.resultDescription);

                        // Priority update logic
                        if (this.currentPage >= 0) {
                          const formData = new FormData();
                          this.dropIndex = this.dropIndex;
                          formData.append('order_id', this.idsss);
                          formData.append('priority', ((noDriverIndexStored + 1)).toString());

                          this.orderService.orderPriority(formData).subscribe(
                            (data: any) => {
                              if (this.authService.resultCodeError(data)) return;

                              this.toast.show('success', data.result);
                              localStorage.setItem('c', '0');
                              this.websocketRefresh.sendOrderListRequest({
                                page: this.currentPage,
                                page_size: 20,
                                search_text: this.searchtext,
                                order_date: this.orderDate,
                                order_status: this.selectedStatuses,
                                order_type: this.orderType,
                                driver_ids: this.driverId
                              });
                              this.subscriptionRefresh =
                                this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                                  // this.handleRefreshData(data);
                                  if (data) {
                                    this.orders = (data.result.results || []).map((order: any) => {

                                      // 🔥 ETA hamesha array banane ka logic
                                      if (order.eta && !Array.isArray(order.eta)) {
                                        // backend se object aa raha hai → array me convert
                                        order.eta = [order.eta];
                                      }

                                      if (!order.eta) {
                                        // null / undefined ho to empty array
                                        order.eta = [];
                                      }

                                      return order;
                                    });
                                    this.totalOrders = data.result.count || 0;
                                    localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                    // console.log('this.orders',this.orders);
                                  }
                                });
                              this.updateSelectionCount();
                              this.fetchOrderCounts();
                              moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                            },
                            (error) => this.authService.dataError(error)
                          );
                        }
                      } else if (response.resultCode === '0') {
                        this.toast.show('error', 'Failed to update order date');
                      }
                    },
                    (error) => {
                      this.toast.show('error', 'Failed to update order date');
                    }
                  );
                })();
              }

              if (
                new Date(draggedItemDate).toDateString() == new Date(dropLocationDate).toDateString()
              ) {
                if (this.currentPage >= 0) {
                  let count = 0;
                  const formData = new FormData();
                  this.dropIndex = this.dropIndex;
                  formData.append('order_id', this.idsss);
                  formData.append('priority', ((noDriverIndexStored + 1)).toString());
                  this.orderService.orderPriority(formData).subscribe(
                    (data: any) => {
                      if (this.authService.resultCodeError(data)) {
                        return;
                      }
                      this.toast.show('success', data.result);
                      localStorage.setItem('c', '0');
                      var storedData = localStorage.getItem('pageIndex');
                      this.websocketRefresh.sendOrderListRequest({
                        page: this.currentPage,
                        page_size: 20,
                        search_text: this.searchtext,
                        order_date: this.orderDate,
                        order_status: this.selectedStatuses,
                        order_type: this.orderType,
                        driver_ids: this.driverId
                      });
                      this.subscriptionRefresh =
                        this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                          // this.handleRefreshData(data);
                          if (data) {
                            this.orders = (data.result.results || []).map((order: any) => {

                              // 🔥 ETA hamesha array banane ka logic
                              if (order.eta && !Array.isArray(order.eta)) {
                                // backend se object aa raha hai → array me convert
                                order.eta = [order.eta];
                              }

                              if (!order.eta) {
                                // null / undefined ho to empty array
                                order.eta = [];
                              }

                              return order;
                            });
                            this.totalOrders = data.result.count || 0;
                            localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                            // console.log('this.orders',this.orders);
                          }
                        });
                      this.updateSelectionCount();
                      this.fetchOrderCounts();
                      // this.orderCount();
                      // this.orderService.getSearchText().subscribe((res)=>{
                      //   if(res && res.length > 0){
                      //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res,this.selectedDriver);
                      //   } else{
                      //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,'',this.selectedDriver)
                      //   }
                      // })
                      moveItemInArray(this.orders, draggedIndex, this.dropIndex);

                    },
                    (error) => {
                      this.authService.dataError(error);
                    }
                  );

                }
                // if(this.page >0){
                //   let count =0 ;
                //   const formData = new FormData();
                //   this.dropIndex =this.dropIndex;
                //   formData.append('order_id', this.idsss);
                //   formData.append('priority', ((noDriverIndexStored+1 +driverCount)).toString());
                //   this.orderService.orderPriority(formData).subscribe(
                //     (data: any) => {
                //         if (this.authService.resultCodeError(data)) {
                //             this.loading = false;
                //             return;
                //         }
                //         this.toastr.success(data?.result);
                //         localStorage.setItem('c','0');
                //         var storedData = localStorage.getItem('pageIndex');
                //         this.page=Number(storedData)
                //          const driverIds = this.selectedDriver.map(driverId => Number(driverId));
                //                     this.orderList1(this.searchtext, this.orderDate, this.selectedStatuss, this.orderType, driverIds, this.page);
                //                     this.orderCount(this.orderDate, this.orderType, this.selectedDriver, this.selectedStatuss, 	 this.searchtext)
                //           // this.orderCount();
                //           // this.orderService.getSearchText().subscribe((res)=>{
                //           //   if(res && res.length > 0){
                //           //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,res,this.selectedDriver);
                //           //   } else{
                //           //     this.orderList(this.orderDate,this.orderType, this.orderStatus, this.page,'',this.selectedDriver)
                //           //   }
                //           // })
                //         moveItemInArray(this.orderData, draggedIndex, this.dropIndex);

                //         this.loading = false;
                //     },
                //     (error) => {
                //         this.authService.dataError(error);
                //         this.loading = false;
                //     }
                // );

                // }
              }

            } else {
              console.log('Selected item is not found in groupedOrders');
            }
          } else {
            console.error('Selected item does not have an id');
          }
        } else {
          // Dragged item belongs to a different driver group than the drop item
          const conditionForDifferentDriver = ' Dragged item belongs to a different driver group than the drop item'/* your condition for different driver */;
          console.log('Condition for different driver:', conditionForDifferentDriver);
          console.log(`Condition for different driver groups: Dragged item belongs to a different driver group than the drop item. Dragged Driver ID: ${draggedDriverId}, Drop Driver ID: ${dropDriverId}, Drop Index: ${this.dropIndex}`, conditionForDifferentDriver);
          // this.updatePriority();
          const noDriverId = dropDriverId;
          let driverName = 'Driver not found';
          this.orders.forEach((order: { current_driver: { id: any; first_name: any; last_name: any; }; }) => {
            if (order.current_driver.id === noDriverId) {
              driverName = order.current_driver.first_name + " " + order.current_driver.last_name;
            }
          });
          const fromDriverName = this.dragdrivername;
          const orderNumber = this.orders[draggedIndex]?.order_no || this.orders[draggedIndex]?.po;
          let enterAnimationDuration = '200ms';
          let exitAnimationDuration = '200ms';

          (async () => {
            const confirmed = await this.dialogService.confirm(
              'Alert?',
              `Do you want to reassign the ${fromDriverName} order to ${driverName}?`,
              'Reassign Order',
              'Cancel'
            );

            if (!confirmed.confirmed) return;

            // User confirmed — proceed with assign
            const formdata = new FormData();
            formdata.append('order_ids', JSON.stringify([Number(this.idsss)]));
            formdata.append('driver_id', noDriverId);

            this.orderService.orderAssign(formdata).subscribe(
              (data: any) => {
                if (this.authService.resultCodeError(data)) return;

                this.toast.show('success', data.resultDescription);
                this.priorityStarts = true;

                if (this.priorityStarts) {
                  this.priorityStarts = false;
                  const selectedItem = this.orders[this.dropIndex];

                  if (selectedItem && selectedItem.id) {
                    const selectedItemId = selectedItem.id;

                    let isInWithDriver = false;
                    let driverGroupKey = null;
                    let driverGroupIndex = -1;

                    // Check in withDriver group
                    for (const driverId in groupedOrders.withDriver) {
                      const driverGroup = groupedOrders.withDriver[driverId];
                      const index = driverGroup.findIndex(
                        (order: { id: any }) => order.id === selectedItemId
                      );
                      if (index !== -1) {
                        isInWithDriver = true;
                        driverGroupKey = driverId;
                        driverGroupIndex = index;
                        break;
                      }
                    }

                    // Check in noDriver group
                    const noDriverIndex = groupedOrders.noDriver.findIndex(
                      (order: { id: any }) => order.id === selectedItemId
                    );
                    const isInNoDriver = noDriverIndex !== -1;

                    if (isInWithDriver) {
                      const driverGroupIndexStored = driverGroupIndex;
                      if (this.currentPage >= 0) {
                        const formData = new FormData();
                        formData.append('order_id', this.idsss);
                        formData.append('priority', (driverGroupIndexStored + 1).toString());

                        this.orderService.orderPriority(formData).subscribe(
                          (data: any) => {
                            if (this.authService.resultCodeError(data)) return;

                            this.toast.show('success', data.result);
                            localStorage.setItem('c', '0');
                            this.websocketRefresh.sendOrderListRequest({
                              page: this.currentPage,
                              page_size: 20,
                              search_text: this.searchtext,
                              order_date: this.orderDate,
                              order_status: this.selectedStatuses,
                              order_type: this.orderType,
                              driver_ids: this.driverId
                            });
                            this.subscriptionRefresh =
                              this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                                // this.handleRefreshData(data);
                                if (data) {
                                  this.orders = (data.result.results || []).map((order: any) => {

                                    // 🔥 ETA hamesha array banane ka logic
                                    if (order.eta && !Array.isArray(order.eta)) {
                                      // backend se object aa raha hai → array me convert
                                      order.eta = [order.eta];
                                    }

                                    if (!order.eta) {
                                      // null / undefined ho to empty array
                                      order.eta = [];
                                    }

                                    return order;
                                  });
                                  this.totalOrders = data.result.count || 0;
                                  localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                  // console.log('this.orders',this.orders);
                                }
                              });
                            this.updateSelectionCount();
                            this.fetchOrderCounts();
                            moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                          },
                          (error) => this.authService.dataError(error)
                        );
                      }
                    } else if (isInNoDriver) {
                      const noDriverIndexStored = noDriverIndex;
                      if (this.currentPage >= 0) {
                        const formData = new FormData();
                        formData.append('order_id', this.idsss);
                        formData.append('priority', (noDriverIndexStored + 1).toString());

                        this.orderService.orderPriority(formData).subscribe(
                          (data: any) => {
                            if (this.authService.resultCodeError(data)) return;

                            this.toast.show('success', data.result);
                            localStorage.setItem('c', '0');
                            this.websocketRefresh.sendOrderListRequest({
                              page: this.currentPage,
                              page_size: 20,
                              search_text: this.searchtext,
                              order_date: this.orderDate,
                              order_status: this.selectedStatuses,
                              order_type: this.orderType,
                              driver_ids: this.driverId
                            });
                            this.subscriptionRefresh =
                              this.ShareddtaServices.refreshdata$.subscribe((data: any) => {
                                // this.handleRefreshData(data);
                                if (data) {
                                  this.orders = (data.result.results || []).map((order: any) => {

                                    // 🔥 ETA hamesha array banane ka logic
                                    if (order.eta && !Array.isArray(order.eta)) {
                                      // backend se object aa raha hai → array me convert
                                      order.eta = [order.eta];
                                    }

                                    if (!order.eta) {
                                      // null / undefined ho to empty array
                                      order.eta = [];
                                    }

                                    return order;
                                  });
                                  this.totalOrders = data.result.count || 0;
                                  localStorage.setItem('ordersCache', JSON.stringify(this.orders));
                                  // console.log('this.orders',this.orders);
                                }
                              });
                            this.updateSelectionCount();
                            this.fetchOrderCounts();
                            moveItemInArray(this.orders, draggedIndex, this.dropIndex);
                          },
                          (error) => this.authService.dataError(error)
                        );
                      }
                    } else {
                      console.log('Selected item is not found in groupedOrders');
                    }
                  } else {
                    console.error('Selected item does not have an id');
                  }
                }
              },
              (error) => this.authService.dataError(error)
            );
          })();


        }
      }
    }

  }



  trackById(index: number, item: any) {
    return item.id;
  }
  scrollSpeed = 30;      // jitna bada, utna tez scroll hoga
  scrollMargin = 50;
  idsss: any;
  sttusses: any;
  currentDriverId: any;
  onItemMoved(id: any, status: any, driverid?: any) {
    this.idsss = id;
    this.sttusses = status;
    this.currentDriverId = driverid;

  }
  handleDragMoved(event: any, item: any): void {
    this.onItemMoved(item.id, item.order_status);
    const scrollContainer = this.tableContainer.nativeElement;
    const containerRect = scrollContainer.getBoundingClientRect();
    const pointerY = event.pointerPosition.y;

    if (pointerY < containerRect.top + this.scrollMargin) {
      scrollContainer.scrollTop -= this.scrollSpeed;  // scroll up
    } else if (pointerY > containerRect.bottom - this.scrollMargin) {
      scrollContainer.scrollTop += this.scrollSpeed;  // scroll down
    }

    // 🔹 Existing logic (uncomment if needed)
    // if (this.is_shipped_admin) {
    //   this.onItemMoved(item.id, item.order_status);
    //   this.onDragMove(event);
    // }
  }
  showAssignOrderModal = false;
  showAssign = false;
  selectedOrders: string[] = [];
  assignorder: boolean = false;
  openAssignOrder() {
    this.assignorder = true
    this.showAssign = true;
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    this.selectedOrders = ids;
    this.showAssignOrderModal = true;
  }
  openReAssignOrder() {
    this.assignorder = true
    this.showAssign = false;
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    this.selectedOrders = ids;
    this.showAssignOrderModal = true;
  }


  handleAssignOrder(event: { driver: string, orders: string[] }) {
    console.log('Assigned Orders:', event.orders, 'to', event.driver);
    const isDriverValid = event.driver.trim() !== '';
    this.assignorder = false;
    if (!isDriverValid) {
      console.warn('Driver not selected!');
      // 🔹 You can set a variable to false
      this.assignorder = false;  // example variable
      return; // exit if driver not valid
    }
    const ids = this.orders
      .filter((o: any) => o.selected)
      .map((o: any) => o.id);
    const formdata = new FormData();
    formdata.append('order_ids', JSON.stringify(ids));
    formdata.append('driver_id', event.driver);  // ✅ yahin se aa raha hai

    this.orderService.orderAssign(formdata).subscribe(
      (data: any) => {
        if (this.authService.resultCodeError(data)) return;
        this.toast.show('success', data.resultDescription);
        this.clearSelection();
      },
      (error) => {
        this.authService.dataError(error);
      }
    );
    // Call API to assign orders here
  }
  totalPages: any;
  itemsPerPage: number = 20;
  getPaginationInfo() {
    const total = this.totalOrders;

    if (!total || total === 0) {
      return 'No orders found';
    }

    // total pages calculate karo
    this.totalPages = Math.ceil(total / this.itemsPerPage);

    // current page ke hisaab se start aur end nikalo
    // const start = (this.currentPage+1-1 ) * this.itemsPerPage + 1;
    // const end = Math.min((this.currentPage+1) * this.itemsPerPage, total);
    const start = 1;
    const end = this.orders.length;
    if (this.orders.length === 0) {
      const start = 0;
      return `Showing ${start} - ${end} of 0 orders`;
    }
    else {
      return `Showing ${start} - ${end} of ${total} orders`;
    }
  }
  goBack(): void {
    window.history.back();
  }
}

